import { render, staticRenderFns } from "./ReportColumnLayoutEditor.vue?vue&type=template&id=d57af61a&scoped=true"
import script from "./ReportColumnLayoutEditor.vue?vue&type=script&lang=js"
export * from "./ReportColumnLayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./ReportColumnLayoutEditor.vue?vue&type=style&index=0&id=d57af61a&prod&scoped=true&lang=css"
import style1 from "./ReportColumnLayoutEditor.vue?vue&type=style&index=1&id=d57af61a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57af61a",
  null
  
)

export default component.exports